module.exports = __webpack_public_path__ + "img/logo.50d62bac.svg";